module.exports = __webpack_public_path__ + "static/media/RKBrowser5w721@1x.eea420ac.webp";